import React from 'react';
import { Box } from '@mui/material';
import InstaTaskMain from 'components/common/InstaTaskMain';
import { PermissionsGate } from 'components/common/PermissionsGate';
import Loader from 'components/common/ui/Loader/Loader';
import { NoAccess } from 'components/common/ui';

import styles from './dSTaskLayout.styles';

const InstaTaskLayout = ({
  tabs,
  header,
  sidebar,
  entity,
  isLoading,
  children,
}) => {
  return (
    <PermissionsGate entity={entity} RenderError={NoAccess} height="100%">
      {isLoading ? (
        <Loader />
      ) : (
        <Box sx={styles.instaTaskLayoutWrapper}>
          {header}
          <Box sx={styles.instaTaskLayoutContentWrapper}>
            {sidebar}
            <InstaTaskMain tabs={tabs} content={children} />
          </Box>
        </Box>
      )}
    </PermissionsGate>
  );
};

export default InstaTaskLayout;
